import { useState } from "react";
import { IconContext } from "react-icons";
import { FiPlus, FiMinus } from "react-icons/fi";

const FAQ = () => {
  const Servicos = [
    {
      id: 1,
      title: "Posso rodar qualquer horário e em qualquer região?",
      text: "Pode, cobertura em todo o território nacional 24hrs.",
    },
    {
      id: 2,
      title: "Quanto tempo para a proteção começar a valer?",
      text: "Geralmente dentro de 24 horas, após aprovação da analise no cadastro",
    },
    {
      id: 3,
      title: "A Proteauto tem carência para utilizar a proteção?",
      text: "Não, após a ativação do veículo na base ele já conta com os beneficios (exceto a cobertura de para-brisa)",
    },
    {
      id: 4,
      title: "Tem fidelidade para permanecer?",
      text: "Não, você pode cancelar caso queira.",
    },
    {
      id: 5,
      title: "O que é taxa de adesão?",
      text: "É uma taxa administrativa para cobrir os custos da associação com a placa cadastrada, rastreador, boletos, vistoria, assistencia etc...",
    },
  ];
  const [clicked, setClicked] = useState(false);

  const toogle = (id) => {
    if (clicked === id) {
      return setClicked(null);
    }
    setClicked(id);
  };

  return (
    <IconContext.Provider value={{ color: "#FF5C48", size: "25px" }}>
      <div className=" ">
        <div className="border rounded-md drop-shadow-sm p-2 mb-2 bg-red-700 text-slate-200 font-bold text-center text-xl">PERGUNTAS FREQUENTES</div>
        <div className="border rounded-md mt-4 px-2 bg-gray-400">
          {Servicos.map((item, id) => {
            return (
              <div key={id}>
                <div className=" border rounded-md drop-shadow-sm flex justify-between  p-3 my-2 bg-white" onClick={() => toogle(id)}>
                  <h1 className="">{item.title}</h1>
                  <span className="my-auto ">{clicked === id ? <FiMinus /> : <FiPlus />}</span>
                </div>
                {clicked === id ? (
                  <div className="border text-gray-700 rounded-md drop-shadow-sm mb-2 flex justify-between p-2 bg-white">
                    <p>{item.text}</p>
                  </div>
                ) : null}
              </div>
            );
          })}
        </div>
      </div>
    </IconContext.Provider>
  );
};

export default FAQ;
